import { Toast } from "vant";
import WeiXinShare from "./weiXinShare";

export default {
  isLogin(userId) {
    const retUrl = encodeURIComponent(window.location.href);
    if (!userId) {
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      // 是否在智农通
      if (isInZnt()) {
        // 智农通登录
        znt.toLogin();
      } else {
        // 微信
        if (this.isInWeiXin()) {
          const ua = navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //eslint-disable-line
            wx.miniProgram.getEnv(res => {
              if (res.miniprogram) {
                // 小程序登录
                this.wxMiniLogin(retUrl);
              } else {
                // 微信登录
                this.wxlogin(retUrl);
              }
            });
          }
        } else {
          this.scH5Login(retUrl);
        }
      }
      setTimeout(() => {
        Toast.clear();
      }, 1000);
      return false;
    }
    return true;
  },
  // 判断是否在微信
  isInWeiXin() {
    // 获取判断用的对象
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //eslint-disable-line
      return true;
    }
    return false;
  },
  scH5Login(retUrl) {
    window.location.href = `${process.env.VUE_APP_CAS}account/login?service=${
      process.env.VUE_APP_APP
    }&systemId=20&retUrl=${retUrl}`;
  },
  wxlogin(retUrl) {
    // 微信授权登录
    window.location.href = `${
      process.env.VUE_APP_APP
    }mob/paymentWeiXin/jumpToAuthorize.do?goodsOrShopUrl=${retUrl}`;
  },
  wxMiniLogin(retUrl) {
    const uuid = this.guid();
    // 小程序登录后返回地址
    let newUrl = retUrl;
    if (!this.checkUrl(retUrl)) {
      newUrl = "";
    }
    wx.miniProgram.navigateTo({
      url: `/pages/h5login/h5login?uuid=${uuid}&retUrl=${newUrl}`,
      complete() {
        // 跳转小程序失败后的处理
        setTimeout(() => {
          this.getAppIdCache(
            uuid,
            () => {
              Toast.clear();
            },
            function () {
              this.scH5Login(retUrl);
            }
          );
        }, 1500);
      }
    });
  },
  checkUrl(urlString) {
    const url = decodeURIComponent(urlString);
    if (url) {
      const reg = /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/; //eslint-disable-line
      if (reg.test(url)) {
        return true;
      }
    }
    return false;
  },
  /**
   * 获取当前缓存的订单APPID
   */
  getAppIdCache(uuid, success, fail) {
    $.ajax({
      type: "GET",
      url: `${process.env.VUE_APP_APP}nos/xcxMember/getAppIdCache/${uuid}`,
      dataType: "json",
      async: false,
      success(data) {
        if (data.data) {
          success();
        } else {
          fail();
        }
      },
      error() {
        fail();
      }
    });
  },
  guid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const //eslint-disable-line
        v = c === "x" ? r : (r & 0x3) | 0x8; //eslint-disable-line
      return v.toString(16);
    });
  },
  // 获取cookie
  getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(";");
    for (let c of ca) {
      while (c.charAt(0) === " ") c = c.substring(1);
      if (c.indexOf(name) !== -1) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  isMobile() {
    return navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|MicroMessenger|miniProgram|harmony)/i
    );
  },
  // 页面跳转
  jumpTo(url, params, options) {
    const opt = { method: "get", target: "_self" };
    if (options) {
      $.extend(opt, options);
    }
    // 创建Form
    const form = $("<form></form>");
    // 设置属性
    let newUrl = url;
    if (url.indexOf("http") === -1) {
      newUrl = `${process.env.VUE_APP_APP}${url}`;
    }
    form.attr("action", newUrl);
    form.attr("method", opt.method);
    // form的target属性决定form在哪个页面提交
    // _self -> 当前页面 _blank -> 新页面
    form.attr("target", opt.target);
    if (params) {
      for (const key in params) {
        //eslint-disable-line
        const myInput = $(`<input type="hidden" name="${key}" />`);
        myInput.attr("value", params[key]);
        // 附加到Form
        form.append(myInput);
      }
    }
    $("body").append(form);
    // 提交表单
    form.submit();
    // return false取消链接的默认动作
    return false;
  },
  initShare(titleShare, descShare, urlShare, imgShare) {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //eslint-disable-line
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          let url = urlShare;
          url = url.indexOf("?") !== -1 ? `${url}&wxminiCusShare=1` : `${url}?wxminiCusShare=1`;
          wx.miniProgram.postMessage({
            data: {
              title: titleShare,
              img: `${imgShare}?imageMogr2/thumbnail/750x600>/format/jpg/size-limit/40k!`,
              url
            }
          });
        } else {
          const paramWeixin = {
            title: titleShare,
            desc: descShare,
            link: urlShare,
            imgUrl: `${imgShare}?imageView2/1/w/100/h/100`
          };
          WeiXinShare.init(paramWeixin);
        }
      });
    }
  }
};
